/**
 * Адрес картинки, видео или файла — из того, что пришло с сервера.
 *
 * С бэкенда ссылки приходят в двух видах: относительным путём (`/uploads/...`)
 * и абсолютным — на хранилище. Раньше каждое место склеивало их само, и вместе
 * с копипастой разъезжались мелочи: где-то `includes('http')` вместо
 * `startsWith`, где-то захардкоженный домен, где-то `undefined` в ссылке.
 *
 * Отдельная забота — прямые ссылки на `s3.regru.cloud`: у части мобильных
 * операторов этот хост не открывается, и картинки просто не грузятся. Сервер
 * уже отдаёт новые ссылки через свой прокси, но в базе остались старые записи,
 * поэтому переписываем их здесь — так починятся и они.
 */

const API_URL = process.env.REACT_APP_API_URL ?? '';

/** Адрес хранилища, как он записан в старых строках базы. */
const S3_ORIGIN = 'https://s3.regru.cloud';

/** Свой прокси к хранилищу: `location /s3/` в nginx. */
const S3_PROXY = (process.env.REACT_APP_S3_PROXY_URL || `${API_URL}/s3`).replace(/\/+$/, '');

/** Ссылки, которые уже готовы к показу и склейки не требуют. */
const ABSOLUTE = /^(https?:|blob:|data:)/i;

export function mediaUrl(src) {
    // Отсутствие файла — это `null`, а не пустая строка: `<img src="">` грузит
    // текущую страницу, а `<Avatar src={null}>` честно показывает заглушку.
    if (!src || typeof src !== 'string') return null;

    if (src.startsWith(S3_ORIGIN)) return S3_PROXY + src.slice(S3_ORIGIN.length);
    if (ABSOLUTE.test(src)) return src;

    return `${API_URL}${src}`;
}

export default mediaUrl;
